import Config from 'react-native-config';
import RNsfmc from 'react-native-marketingcloudsdk';

export class SfmcUtil {
  mcSDK: any;

  constructor() {
    this.mcSDK = RNsfmc;
  }

  setContactKey = (contactKey: any) => {
    if (!(Config.ALLOW_SFMC === 'TRUE')) return;
    this.mcSDK.setContactKey(contactKey);
    this.mcSDK.logSdkState();
  };
}

let sfmcInstance: any = null;
export const getSfmcInstance = () => {
  if (sfmcInstance === null) {
    sfmcInstance = new SfmcUtil();
  }
  return sfmcInstance;
};
